import React, {
  FunctionComponent,
  MouseEvent,
  useEffect,
  useState,
} from "react";
import { createPortal } from "react-dom";
import styled from "styled-components";
import { ModalProps } from "../../interfaces/interfaces";
import { isBrowser } from "../../utils";

const Modal: FunctionComponent<ModalProps> = ({
  open,
  onClose,
  onOpen,
  className,
  closable,
  children,
}) => {
  const [isOpen, setIsOpen] = useState(open);

  useEffect(() => {
    if (open) {
      onOpen && onOpen();
    }
    setIsOpen(open);
  }, [open]);

  const onOutsideClick = (event: MouseEvent) => {
    const target = event.nativeEvent.target as HTMLElement;
    const isOverlay = target.classList.contains("modal");
    if (isOverlay) {
      setIsOpen(false);
      onClose && onClose();
    }
  };

  const onOutsideClick2 = (event: MouseEvent) => {
    const target = event.nativeEvent.target as HTMLElement;
    const isOverlay = target.classList.contains("closable");
    if (isOverlay) {
      setIsOpen(false);
      onClose && onClose();
    }
  };

  return isBrowser ? createPortal(
    <StyledModal
      className={`modal ${className ? className : ""}`}
      styles
      isOpen={isOpen}
      onClick={onOutsideClick}
    >
      <div className="content">
        <StyledClosed styles isOpen={isOpen}>
          {/* {closable && ( */}
            <div className="closable" onClick={onOutsideClick2}>
              X
            </div>
          {/* )} */}
        </StyledClosed>
        {children}
      </div>
      </StyledModal>,
    document.body
  ):null;
};

const StyledModal = styled.div`
  display: ${({ isOpen }: { isOpen: boolean }) => (isOpen ? "grid" : "none")};
  justify-content: center;
  align-items: safe center;
  height: 100vh;
  width: 100vw;
  position: absolute;
  overflow: scroll;
  top: 0;
  left: 0;
  z-index: 99999999;
  background-color: #fff000db;
  position: fixed;
`;

const StyledClosed = styled.div`
  display: ${({ isOpen }: { isOpen: boolean }) => (isOpen ? "block" : "none")};

  width: 100%;
  position: relative;
  font-family: sofia-pro,sans-serif;
  font-weight: 700;
  color: #fff;
  background-color: transparent;
  top: 0;
  left: 0;
  z-index: 99999999;
  .xcontain {
    position: absolute;
    top: 0px;
    right: 0px;
    padding: 5px;
    background-color: #fff;
    margin-bottom: -10px;
    text-align: center;
    width: 30px;
    cursor: pointer;
  }
`;

export default Modal;
